export default "__VITE_ASSET__814fec96__"